import axios from 'axios'
// const Debugger = true // 是否开启Debugger打印请求结果
/* header参数配置 */
let header = {
  'Content-Type': 'application/x-www-form-urlencoded'
}
/* 防止参数中敏感字符丢失的问题 */
const HasSensitiveCharacter = true
if (HasSensitiveCharacter) {
  header['Content-Type'] = 'application/json'
}
// 初始化一个axios对象
axios.create({
  // baseURL: 'https://person.mobile.kequbang.com', // api的base_url
  baseURL: 'https://person.kequbang.com', // api的base_url
  // baseURL: 'http://192.168.2.12:8080',
  timeout: 5000, // request timeout
  headers: header
})
// 请求拦截器
axios.interceptors.request.use(
  config => {
    console.log(config)
    config.data = config.data || {}
    return config
  },
  error => {
    return Promise.reject(error)
  }
)
// 响应拦截器
axios.interceptors.response.use(
  response => {
    // console.log(response)
    return response.data
  },
  error => {
    return Promise.reject(error)
  }
)
export default axios
